


































import Vue from 'vue';
import CandidateService from '~/services/CandidateServiceOld';
import { CV } from '~/services/CVService';
import DialogService from '~/services/DialogService';
import EducationSkeleton from '~/views/spotlight/skeletons/EducationSkeleton.vue';
import CVItem from './CVItem.vue';
import { MessageState } from '~/store/customModules/messageModule';
import AnalyticService from '~/services/AnalyticService';

export default Vue.extend({
    name: 'CV',
    components: {
        EducationSkeleton,
        CVItem,
    },
    data() {
        return {};
    },
    computed: {
        cvrequest(): any {
            return (this as any).$interfaces.candidate.cv.list.get({ reactive: true });
        },
        cvs(): Array<CV> {
            if (this.cvrequest.loading) {
                return [];
            } else {
                return this.cvrequest.data;
            }
        },
        isLoading(): boolean {
            return this.cvrequest.loading;
        },
    },
    methods: {
        isTypeOk(type: string) {
            return type.match(
                'application/pdf|application/vnd.openxmlformats-officedocument.wordprocessingml.document|application/msword'
            );
        },
        reload() {
            (this as any).$interfaces.candidate.cv.list.get({ reactive: true, forceUpdate: true });
        },
        uploadClicked() {
            (this.$refs['fileInput'] as any).click();
        },
        onFileChange(name: any, files: FileList) {
            if (files.length > 0) {
                let imageFile = files[0];
                if (!this.isTypeOk(imageFile.type)) {
                    (this as any).$interfaces.messageModule.addNewMessage({
                        title: this.$t('spotlight.personalDetails.wrongFileTypeErrorHeader'),
                        message: this.$t('documents.cv.fileFormatInfo'),
                        state: MessageState.ERROR,
                        duration: 6000,
                    });
                } else {
                    DialogService.openUploadCVDialog(files[0], {
                        uploaded: () => {
                            AnalyticService.impressionEvent(
                                AnalyticService.IMPRESSION_ACTIONS.CV_UPLOAD_ACTION
                            );
                            this.reload();
                        },
                    });
                }
            }
        },
        onDelete(cv: CV) {
            (this as any).$interfaces.dialogModal.openModal({
                title: cv.fileName,
                content: this.$t('documents.cv.areYouSure'),
                isError: false,
                clickawayOff: false,
                actions: [
                    {
                        title: this.$t('general.delete'),
                        variant: 'secondary',
                        action: ({ res }: any) => {
                            CandidateService.deleteCV(cv.id).then(() => {
                                this.reload();
                                res('close');
                            });
                        },
                    },
                    {
                        title: this.$t('general.cancel'),
                        variant: 'secondary',
                        action: ({ res }: any) => res('close'),
                    },
                ],
            });
        },
        onDefault(cv: CV) {
            (this as any).$interfaces.dialogModal.openModal({
                title: cv.fileName,
                content: this.$t('documents.cv.setDefaultInfo'),
                isError: false,
                clickawayOff: false,
                actions: [
                    {
                        title: this.$t('general.ok'),
                        variant: 'secondary',
                        action: ({ res }: any) => {
                            CandidateService.setDefaultCV(cv.id).then(() => {
                                this.reload();
                                res('close');
                            });
                        },
                    },
                    {
                        title: this.$t('general.cancel'),
                        variant: 'secondary',
                        action: ({ res }: any) => res('close'),
                    },
                ],
            });
        },
    },
    mounted() {},
});
